<template>
  <div class="max-w-sm w-[90%] bg-white border border-gray-200 rounded-lg shadow-md anim">
    <img
      class="rounded-t-lg max-h-40 w-full"
      :src="
      sectors.banner && sectors.banner !== '[]' ?
        imageServe + sectors.banner :
        defaultBg
      "
      alt="banner do evento"
    />

    <div class="flex justify-end px-4 py-4">
      <button
        :id="'dropdownButton'+sectors.id"
        :data-dropdown-toggle="'dropdown'+sectors.id"
        class="inline-block text-gray-500 hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-200 rounded-lg text-sm p-1.5 mb-2"
        type="button"
      >
        <span class="sr-only">Open dropdown</span>
        <svg
          class="w-5 h-5"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          viewBox="0 0 16 3"
        >
          <path
            d="M2 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm6.041 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM14 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Z"
          />
        </svg>
      </button>

      <!-- options -->
      <div
        :id="'dropdown'+sectors.id"
        class="z-10 hidden text-base list-none bg-white divide-y divide-gray-100 rounded-lg shadow-sm w-44 border"
      >
        <ul class="py-2" :aria-labelledby="'dropdownButton'+sectors.id">
          <li>
            <a
              @click="$emit('setUpdateForm', sectors.id)"
              class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer"
              >
              Alterar
            </a>
          </li>
          <li>
            <a
              @click="removeEvent(sectors.id)"
              class="block px-4 py-2 text-sm text-red-600 hover:bg-gray-100 cursor-pointer"
              >Remover</a
            >
          </li>
        </ul>
      </div>
    </div>

    <div class="px-2 pb-2 -mt-4">
      <a>
        <h5 class="mb-2 text-xl font-bold tracking-tight text-gray-900 grid">
          {{ sectors.title }}

          <small v-if="sectors.tag" class="text-gray-400 text-xs font-medium tracking-wider">
            card:
            <small class="text-gray-700 font-bold">
              {{ sectors.tag }}
            </small>
          </small>

          <small v-if="sectors.participants?.length > 0" class="text-gray-400 text-xs font-medium tracking-wider">
            participantes:
            <small class="text-gray-700 font-bold">
              {{ sectors.participants?.length }}
            </small>
          </small>

        </h5>
      </a>
    </div>

  </div>
</template>

<script setup>
import { storeApp } from '@/store'
import { showToast as toast } from '@/helpers/UseToasts'
import {
  PhClockAfternoon as ClockIcon,
  PhCheckCircle as CheckIcon,
  PhGearSix,
  PhArrowRight,
  PhDotsThreeOutline
} from '@phosphor-icons/vue'
import { initFlowbite } from 'flowbite'
import { ref, defineProps, onMounted } from 'vue'

import { dataEvent } from '../../store'
import EventService from '../../service/event.service'

const defaultBg = require('@/assets/img-default-sectors.webp')
const imageServe = process.env.VUE_APP_IMAGE_SERVE + 'storage/'
const props = defineProps({
  id: {
    type: Number,
    required: true
  },
  sectors: {
    type: [Array, Object],
    required: true
  }
})

async function removeEvent (id) {
  storeApp.state.loading = true

  await EventService.removeEventById(id)
    .then(res => {
      if (res?.data?.success) {
        dataEvent.dispatch('setAllEvents', res?.data?.events)

        toast(
          'Sucesso',
          res.data.message,
          'success'
        )
      }

      storeApp.state.loading = false
    }).catch(err => {
      storeApp.state.loading = false

      if (err?.response?.data?.error && err.response.data.status === 404) {
        return toast(
          'Aviso',
          err.response.data.message,
          'error'
        )
      }

      return toast(
        'Aviso',
        'Algo deu errado ao remover evento',
        'error'
      )
    })
}

onMounted(() => {
  initFlowbite()
})
</script>

<style lang="scss">
.anim {
  transition-duration: .5s;

  &:hover {
    transform: translateY(-5px);
    transition-duration: 0.3s;
  }
}
</style>
